<template>
  <div>
    <p>
      <span v-if="hasTime" class="text-danger font-weight-bold">
        <span v-if="hasDays">{{ days }} {{ daysString }}, </span>
        <span v-if="hasHours">{{ hours }} {{ hoursString }}, </span>
        <span v-if="hasMinutes">{{ minutes }} {{ minutesString }} {{ $t('messages.and') }} </span>
        <span v-if="hasSeconds">{{ seconds }} {{ secondsString }} </span>
      </span>
      <span v-if="!hasTime" class="text-danger font-weight-bold">{{ $t('messages.expired') }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'countdown',
  props: {
    date: {
      type: String,
      required: true
    },
    expiredCallback: {
      type: Function,
      required: false
    }
  },
  data: function () {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      target: new Date(this.date.replace(/-/g, '/')).getTime() / 1000
    }
  },
  computed: {
    seconds: function () {
      return (this.target - this.now) % 60
    },
    secondsString: function () {
      if (this.seconds === 1) {
        return this.$i18n.t('time.second')
      } else {
        return this.$i18n.t('time.seconds')
      }
    },
    hasSeconds: function () {
      return this.seconds > 0 || this.hasMinutes
    },
    minutes: function () {
      return Math.trunc((this.target - this.now) / 60) % 60
    },
    minutesString: function () {
      if (this.minutes === 1) {
        return this.$i18n.t('time.minute')
      } else {
        return this.$i18n.t('time.minutes')
      }
    },
    hasMinutes: function () {
      return this.minutes > 0 || this.hasHours
    },
    hours: function () {
      return Math.trunc((this.target - this.now) / 60 / 60) % 24
    },
    hoursString: function () {
      if (this.hours === 1) {
        return this.$i18n.t('time.hour')
      } else {
        return this.$i18n.t('time.hours')
      }
    },
    hasHours: function () {
      return this.hours > 0 || this.hasDays
    },
    days: function () {
      return Math.trunc((this.target - this.now) / 60 / 60 / 24)
    },
    daysString: function () {
      if (this.days === 1) {
        return this.$i18n.t('time.day')
      } else {
        return this.$i18n.t('time.days')
      }
    },
    hasDays: function () {
      return this.days > 0
    },
    hasTime: function () {
      return this.hasSeconds || this.hasMinutes || this.hasHours || this.hasDays
    }
  },
  mounted: function () {
    if (!this.hasTime) {
      this.expiredCallback(true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/Countdown.vue